import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const BoldContentBlock = ({
  key,
  content=null
}) => {
  return (
    <div className="bold-content-block">
      <div className="container">
        <div className="row jcc">
          <div className="col-12 col-lg-10 col-xl-6">
            {content &&
              <h2 className="content-title center mv1">{ htmlDecode(content) }</h2>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default BoldContentBlock
